const en_US = {
  platform: 'Zespri EC Review Analytical & Insights Platform',
  Forget_Password: 'Forget Password',
  Log_In: 'Log In',
  Welcome: 'Welcome,',
  Confirm: 'Confirm',
  Product: 'Product',
  View_original: 'View Consumer Verbatim',
  FruitCommentsShare: 'Product Review %',
  FruitComments_MOM: 'Product Review MOM',
  FruitComments_YOY: 'Product Review YOY',

  Trendpopularity_Fruit: 'Product Review Volume Trend',
  Channelcomment_popularity: 'Channel Review Volume %',
  Channelcomments_emotions: 'Channel Review Sentiment %',
  TrendFruit_EmotionalHeat: 'Product Review Sentiment Trend',
  Trendproportion_emotions: 'Proportion of fruit emotions',
  Attributenegative_emotion: 'Attribute Negative Sentiment %',
  Attributepositive_emotion: 'Attribute Positive Sentiment %',
  Trendattributeemotion_proportion: 'Attribute Sentiment Trend',
  ComparisonAttributeEmotion_Proportion:
    'Attribute Sentiment Comparison by Product Types',
  WordCloud: 'Word Cloud',
  Data_Definition: 'Data Definition',
  WordCloudRanking: 'Word Cloud Ranking',
  dataInfo:
    'This system officially started data collection on July 1, 2024. Data prior to this date is backfilled and may be incomplete; please use it for reference only. If "Previous Period" data in the year-over-year charts falls within the backfill period, we recommend manually deselecting it to ensure analytical accuracy.',
}
export default en_US
